// Libraries
var React = require('react');

// Styles
require('./ArchivedBanner.scss');

// Assets
var logoImg = require('images/logo.svg');

class ArchivedBannerModule extends React.Component {

	render() {
		return (
			<div className="ArchivedBanner">
				<div className="ArchivedBanner__container">
					<div className="ArchivedBanner__image">
						<img src={logoImg} alt="" />
					</div>
					<div className="ArchivedBanner__content">
						<p>This is archive content and, therefore, you may experience some formatting issues.</p>
					</div>
				</div>
			</div>
		)
	}
}

module.exports = ArchivedBannerModule;



// WEBPACK FOOTER //
// ./src/components/ArchivedBanner/ArchivedBannerModule.js